module.exports = __webpack_public_path__ + "img/logo_bottom.97418a18.png";